// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// Utils
import {
    getNotificationBoardTitle,
    getNotificationElementId,
} from '../../../../../../../common/notifications/notificationModelUtils';
import { getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { chooseSingular } from '../../../../../../../common/utils/stringUtil';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import UserNames from './UserNames';
import NotificationUserFigure from './NotificationFigureUser';
import Icon from '../../../../../../components/icons/Icon';

const BoardTitle = (props) => {
    const { group, element, notification } = props;

    const groupId = get('id', group);
    const boardId = getNotificationElementId(notification);

    if (groupId === boardId) return null;

    const boardTitle = getTitle(element) || getNotificationBoardTitle(notification);

    if (!boardTitle) return <span> in a board</span>;

    return (
        <span>
            {' '}
            in <span className="board-title">{boardTitle}</span>
        </span>
    );
};

const NotificationEntryBoardView = (props) => {
    const { actors } = props;

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryBoardView"
            figure={<NotificationUserFigure {...props} icon={<Icon name="notification-viewed" />} />}
        >
            <div className="notification-statement">
                <UserNames users={actors} /> {chooseSingular(actors.length, 'has ', 'have')} seen your changes
                <BoardTitle {...props} />
            </div>
        </BaseNotificationEntry>
    );
};

BoardTitle.propTypes = NotificationEntryBoardView.propTypes = {
    element: PropTypes.object,
    group: PropTypes.object,
    actors: PropTypes.array,
    notification: PropTypes.object,
    previousLastCheckedNotifications: PropTypes.number,
};

export default NotificationEntryBoardView;
